import { AccordionDetailsHandler } from '@ig_accordion/Build/Sources/TypeScript/accordion.core.ts';
import accordionDefaultConfig from '@ig_accordion/Build/Sources/TypeScript/accordion.defaults.ts';

declare const breakpoint: number;

window.accordionHandler = new AccordionDetailsHandler('ig-accordion', breakpoint, accordionDefaultConfig);
